import { useCallback, useEffect } from 'react';
import { setCurrentActiveDashboard } from '@src/store/tempDashboard/actions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isAppModule } from '@src/utils/constants';
import { useResetError } from './useSetError';

export const useResetForPreset = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const resetError = useResetError();
  const callback = useCallback(() => {
    if (isAppModule) {
      resetError();
      dispatch(setCurrentActiveDashboard({}));
    }
  }, [dispatch, resetError]);

  useEffect(() => {
    window.addEventListener('popstate', callback);
    return () => {
      window.addEventListener('popstate', callback);
    };
  }, [navigate, callback]);
};
